// tslint:disable: completed-docs
import produce from 'immer';
import {IInitialState} from './types';
import {
    TRACK_ACCORDION_OPEN_SUCCESS,
    TRACK_APPLY_FILTER_SUCCESS,
} from 'Container/Tracking/constant';
import {
    ACCORDION_OPENED,
    HOTLINE_BUTTON_CLICK, NOTIFICATION_HOTLINE_LINK_CLICK,
    SELECT_MULTIPICKER_SUCCESS,
} from 'Container/Landingpage/constant';

// tslint:disable-next-line: completed-docs
export const initialState: IInitialState = {
    hotlineNumber: false,
    openedAccordionOfferId: false,
    alreadyTrackedAccordion: [],
    alreadyTrackedAppliedFilter: [],
};

/**
 * Update list of simOnly in state or the error in case of API failed
 *
 * @export {function} preDataHandlerReducer
 * @param {*} state - Initial state of the app
 * @param {*} action - The action dispatched from saga
 */
const trackingReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case ACCORDION_OPENED:
                draft.openedAccordionOfferId = action.offerId;
                break;
            case HOTLINE_BUTTON_CLICK:
            case NOTIFICATION_HOTLINE_LINK_CLICK:
                draft.hotlineNumber = action.phoneNumber;
                break;
            case SELECT_MULTIPICKER_SUCCESS:
                draft.alreadyTrackedAccordion = [];
                draft.alreadyTrackedAppliedFilter = [];
                break;
            case TRACK_APPLY_FILTER_SUCCESS:
                if ('boolean' !== typeof draft.alreadyTrackedAppliedFilter) {
                    draft.alreadyTrackedAppliedFilter.push(action.offerId);
                } else {
                    draft.alreadyTrackedAppliedFilter = [action.offerId];
                }
                break;
            case TRACK_ACCORDION_OPEN_SUCCESS:
                if ('boolean' !== typeof draft.alreadyTrackedAccordion) {
                    draft.alreadyTrackedAccordion.push(action.offerId);
                } else {
                    draft.alreadyTrackedAccordion = [action.offerId];
                }
                break;
        }
    });

export default trackingReducer;
